module.exports = __webpack_public_path__ + "assets/img/rwLogo.71ee3841.png";